import React from 'react';
import AffiliateManagementPage from './affiliate';

export default function AffiliateManagement() {
  return <AffiliateManagementPage />;
}
